<router-outlet></router-outlet>
<div #yandexMetrics class='yandex-metrics'></div>

<p-toast [key]="ToastKey.main" [baseZIndex]="5000"></p-toast>

<p-toast position="bottom-center" [key]="ToastKey.appComponentBottomNotificator" [preventDuplicates]="true" [baseZIndex]="5000">
  <ng-template let-message #message>
    <div class="app__session-notificator__wrapper">
      @if (message?.icon) {
        <section class="app__session-notificator__icon__wrapper">
          <i [class]="message.icon" aria-hidden="true"></i>
        </section>
      }
      <section class="app__session-notificator__content__wrapper">
        <header class="app__session-notificator__header__wrapper">{{ message.detail }}</header>
        <section class="app__session-notificator__details__wrapper">{{ message.summary }}</section>
      </section>
    </div>
  </ng-template>
</p-toast>

<p-confirmDialog
  #appVersionUpdateDialog
  [key]="ConfirmDialogKeys.appVersionUpdate"
  appendTo="body"
  styleClass="confirm-dialog"
>
  <ng-template pTemplate="footer">
    <p-button
      severity="secondary"
      [label]="'button.cancel' | translate"
      (onClick)="appVersionUpdateDialog.onReject()"
    />
    <p-button
      [text]="true"
      [label]="'app.reload' | translate"
      (onClick)="appVersionUpdateDialog.onAccept()"
    />
  </ng-template>
</p-confirmDialog>

<p-block-ui [blocked]="progressLoadingService.loading()">
  <div class="w-full h-full flex justify-content-center align-items-center">
    <p-progress-spinner ariaLabel="loading" strokeWidth="5"/>
  </div>
</p-block-ui>
